if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      this.hazmatProId = theme.settings.hazmatProId || '44451573727388';
      this.hazmatLimitedId = theme.settings.hazmatLimitedId || '44451520512156';
      this.tempSensProId = theme.settings.tempSensProId || '44451517857948';
    }

    async cartAdditionalItems() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        return {
          hasHazmatPro: cart.items.some(item => item.variant_id === Number(this.hazmatProId)),
          hasHazmatLimited: cart.items.some(item => item.variant_id === Number(this.hazmatLimitedId)),
          hasTempSensPro: cart.items.some(item => item.variant_id === Number(this.tempSensProId))
        };
      } catch (error) {
        console.error('Failed to fetch cart:', error);
        return { hasHazmatPro: false, hasHazmatLimited: false, hasTempSensPro: false };
      }
    }

    processHazmat(content, state) {
      const template = content.querySelector(".hazmat-item");
      if (!template) return;

      const current = this.querySelector(".hazmat-item");
      const templateId = template.querySelector(".item-id")?.value;
      const isProTemplate = templateId === this.hazmatProId;

      const shouldRemove = state.hasHazmatPro || state.hasHazmatLimited;
      const shouldAddLimited =
        !state.hasHazmatPro && !state.hasHazmatLimited && !isProTemplate;

      const shouldAddOrUpgradePro =
        !state.hasHazmatPro && isProTemplate;

      /* ---- REMOVE ---- */
      if (shouldRemove) {
        if (current) current.remove();
        return;
      }

      /* ---- ADD LIMITED ---- */
      if (shouldAddLimited && !current) {
        this.appendTemplate(state.productForm, template);
        return;
      }

      /* ---- ADD / UPGRADE PRO ---- */
      if (shouldAddOrUpgradePro) {
        if (!current) {
          this.appendTemplate(state.productForm, template);
        } else {
          const input = current.querySelector(".item-id");
          if (input) input.value = this.hazmatProId;
        }
      }
    }

    /* =========================
      TEMP SENSITIVE
    ========================= */

    processTempSensitive(content, state) {
      const template = content.querySelector(".temp-item");
      if (!template) return;

      const current = this.querySelector(".temp-item");
      const templateId = template.querySelector(".item-id")?.value;
      const isProTemplate = templateId === this.tempSensProId;

      if (!state.hasTempSensPro && isProTemplate) {
        if (!current) this.appendTemplate(state.productForm, template);
      } else if (current) {
        current.remove();
      }
    }


    /* =========================
      UTIL
    ========================= */

    appendTemplate(container, template) {
      container.insertAdjacentHTML("beforeend", template.outerHTML);
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;
      evt.preventDefault();
      
      const productForm = this.querySelector(".js-product-form");
      const additionalItems = this.querySelectorAll("template.additional-item");

      if(additionalItems.length > 0) {
        let { hasHazmatPro, hasHazmatLimited, hasTempSensPro } = await this.cartAdditionalItems();

        const isProProduct = Array.from(additionalItems).some(item =>
          item.content.querySelector('.hazmat-item .item-id')?.value === this.hazmatProId
        );
        if (isProProduct && hasHazmatLimited && !hasHazmatPro) {
          try {
            const res = await fetch(theme.routes.cartChange, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: this.hazmatLimitedId, quantity: 0 })
            });
            if (!res.ok) {
              const err = await res.json();
              throw new Error(err.description || 'Failed to remove limited fee');
            }
            hasHazmatLimited = false;
          } catch (error) {
            console.error('Error removing limited hazmat fee:', error.message);
          }
        }

        additionalItems.forEach(({ content }) => {
          this.processHazmat.call(this, content, {
            hasHazmatPro,
            hasHazmatLimited,
            productForm,
          });

          this.processTempSensitive.call(this, content, {
            hasTempSensPro,
            productForm,
          });
        });

        additionalItems.forEach((item) => {
          const hazmatItem = item.content.querySelector(".hazmat-item");
          const tempItem = item.content.querySelector(".temp-item");

          if(hazmatItem) {
            const itemId = hazmatItem.querySelector(".item-id")?.value;
            const targetHazmat = itemId === this.hazmatProId ? 'pro' : 'limited';
            const currentHazmatItem = this.querySelector(".hazmat-item");

            if(!hasHazmatPro || !hasHazmatLimited) {
              if(targetHazmat === 'limited' && !hasHazmatPro && !hasHazmatLimited) {
                if (!currentHazmatItem) {
                  this.querySelector(".js-product-form").innerHTML += hazmatItem.outerHTML;
                }
              } else if(targetHazmat === 'pro' && !hasHazmatPro) {
                if (!currentHazmatItem) {
                  this.querySelector(".js-product-form").innerHTML += hazmatItem.outerHTML;
                } else {
                  currentHazmatItem.querySelector(".item-id").value = this.hazmatProId;
                }
              } else if(hasHazmatPro || hasHazmatLimited) {
                if (currentHazmatItem) {
                  currentHazmatItem.remove();
                }
              }
            }
            
          }

          if(tempItem) {
            if(!hasTempSensPro && (tempItem.querySelector(".item-id").value === this.tempSensProId)) {
              if(!this.querySelector(".temp-item")){
                this.querySelector(".js-product-form").innerHTML += tempItem.outerHTML;
              }
            } else {
              const currentTempSensItem = this.querySelector(".temp-item");
              if(currentTempSensItem) {
                currentTempSensItem.remove();
              }
            }
          }
          
        });
      }

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);


      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`, { cache: 'no-store' });
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        let response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        let data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        // Shopify can reject the very first cart mutation of a brand-new buyer
        // session with a false "can't purchase for this location" error while it
        // finishes resolving the cart's market/currency context (seen right after
        // the intended-use certification redirect). Retrying once, after re-priming
        // with a fresh uncached cart read, resolves it without the customer having
        // to reload the page themselves.
        if (data.status && typeof error === 'string' && /can.?t purchase|this location/i.test(error)) {
          await new Promise((resolve) => setTimeout(resolve, 600));
          await fetch(`${theme.routes.cart}.js`, { cache: 'no-store' });

          response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
          data = await response.json();
          error = typeof data.description === 'string' ? data.description : data.message;
          if (data.errors && typeof data.errors === 'object') {
            error = Object.entries(data.errors).map((item) => item[1].join(', '));
          }
        }

        //console.log('arn::data::', data);

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          const hasUpCart = window.__upcartFetchPatched || typeof window.upcartOpenCart === 'function';

          setTimeout(() => {
            // Update cart drawer contents — skip when UpCart is active (it handles its own drawer).
            if (this.cartDrawer && !hasUpCart) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
              document.dispatchEvent(new CustomEvent('on:cart-drawer:updated', {detail: { completed: true }}));
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        
        // if(this.additionalItems && this.additionalItems.length > 0) {
        //   this.additionalItems.forEach((item) => {
        //     item.remove();
        //   });
        // }
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      const cartIconDesktop = document.querySelector('.header__cart-count-number');
      const cartIcon = document.getElementById('cart-icon');
      // if (cartIconBubble) {
      //   cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      // }

      // if (cartIconDesktop) {
      //   cartIconDesktop.innerHTML = response.sections['cart-icon-desktop'].split("<!--")[1].split("-->")[0].trim();
      // }

      if (cartIcon) {
        cartIcon.innerHTML = new DOMParser().parseFromString(response.sections['cart-icon-bubble'], 'text/html').querySelector(".shopify-section").innerHTML;
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
